
import { defineComponent } from 'vue';
import CategoryBoxComponent from './CategoryBoxComp.vue';

export default defineComponent({
	name: 'CategoryBoxesComponent',
	components: {
		CategoryBoxComponent
	}
})
